import { render, staticRenderFns } from "./RemoveContainer.vue?vue&type=template&id=09fd3524&scoped=true"
import script from "./RemoveContainer.vue?vue&type=script&lang=js"
export * from "./RemoveContainer.vue?vue&type=script&lang=js"
import style0 from "./RemoveContainer.vue?vue&type=style&index=0&id=09fd3524&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd3524",
  null
  
)

export default component.exports